import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class EnterpriseInforApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'enterpriseinfor'
    }


    /**
     * 查询企业分页列表
     * @returns 
     */
    public getEntitiesPage(params){
        return this.send(params,"getEntitiesPage",Methods.GET)
    }

    /**
     * 企业保存
     * @param params
     */
    public saveObj(params){
        return this.send(params,"saveObj",Methods.POST)
    }

    /**
     * 删除
     * @param id
     */
    public updateDelFlag(id){
        return this.send({},"updateDelFlag?id="+id,Methods.POST)
    }

   
}